/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React, { Component } from 'react';
import { Fade } from 'react-awesome-reveal';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

export default class CareerPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <section className="hero sm:items-center lg:items-start sm:flex-row">
          <div className="w-full sm:w-2/3 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
            <Fade direction="up" triggerOnce>
              <h1 className="text-6xl text-theme-blue font-bold leading-tight mb-5">
                Careers
              </h1>
            </Fade>
            <Fade direction="up" delay={300} triggerOnce>
              <p className="font-light text-xl text-gray-400 leading-relaxed">
                Join a team that builds impactful software. We value curiosity,
                ownership, and collaboration.
              </p>
            </Fade>
          </div>
        </section>

        <section className="container mx-auto px-6 lg:px-0">
          <div className="bg-white rounded-2xl shadow border border-light-theme-purple p-6">
            <h2 className="text-2xl text-theme-blue mb-4">Open Roles</h2>
            <ul className="list-disc pl-6 text-gray-400 space-y-2">
              <li>Full Stack Developer (React/Node)</li>
              <li>Mobile Developer (Flutter/React Native)</li>
              <li>UI/UX Designer</li>
              <li>Business Analyst</li>
            </ul>
            <p className="text-gray-400 mt-4">
              Send your profile to
              {' '}
              <span className="text-theme-purple">hr@zerlak.com</span>
            </p>
          </div>
        </section>

        <Footer />
      </>
    );
  }
}
